<template>
  <div class="add-form">
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">报警类型</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="monitor.rule_type" type="button">
          <Radio :label="1">计划报警</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field row-item-must">媒体</span>
      </Col>
      <Col span="12">
        <el-select v-model="monitor.mediaIds" multiple filterable style="width: 420px">
          <el-option v-for="p in mediaData" :key="p.id" :value="p.id" :label="p.name"></el-option>
        </el-select>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field row-item-must">游戏组</span>
      </Col>
      <Col span="12">
        <el-select v-model="monitor.game_group_ids" multiple clearable filterable :multiple-limit="50" style="width: 420px">
          <el-option v-for="p in groupData" :key="p.id" :value="p.id" :label="p.name"></el-option>
        </el-select>
        <span>{{ monitor.game_group_ids.length }}/50</span>
      </Col>
    </Row>

    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field row-item-must">平台</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="monitor.platform" type="button">
          <Radio :label="0">全部</Radio>
          <Radio :label="2">IOS</Radio>
          <Radio :label="1">安卓</Radio>
          <Radio :label="3">小游戏</Radio>
        </RadioGroup>
      </Col>
    </Row>

    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field row-item-must">触发条件</span>
      </Col>
      <condition
        v-model="monitor.monitorCondition"
        :data="ruleData"
        :satisfy="monitor.satisfy"
        :verify="formErr"
        @on-change="changeSatisfy"
      ></condition>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">数据统计周期</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="monitor.data_range" type="button">
          <Radio :label="0">今日实时</Radio>
          <Radio :label="1">昨天</Radio>
          <Radio :label="2">近3天</Radio>
          <Radio :label="3">近7天</Radio>
          <Radio :label="4">上一周</Radio>
          <Radio :label="5">上一月</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">监控频率</span>
      </Col>
      <Col span="8">
        <el-select v-model="monitor.monitor_time.type" style="width: 120px">
          <el-option
            v-for="p in [{ label: '每天', value: 'day' }]"
            :disabled="p.disabled"
            :key="p.value"
            :value="p.value"
            :label="p.label"
          ></el-option>
        </el-select>
        <span>&ensp;</span>

        <el-select v-model="monitor.monitor_time.value" multiple clearable collapse-tags style="width: 150px">
          <el-option v-for="(time, index) in times" :key="index" :value="index" :label="time"></el-option>
        </el-select>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field">提醒类型</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="monitor.alert_type" type="button">
          <Radio :label="1">仅钉钉</Radio>
          <Radio :label="2">仅邮件</Radio>
          <Radio :label="3">钉钉+邮件</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field row-item-must">提醒人员</span>
      </Col>
      <Col span="12">
        <el-select v-model="monitor.operators" multiple filterable :popper-append-to-body="false" style="width: 320px">
          <el-option v-for="p in operatorData" :key="p.id" :value="p.id" :label="p.name"></el-option>
        </el-select>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="3" class="col-item">
        <span class="item-field row-item-must">规则名称</span>
      </Col>
      <Col span="12">
        <input-len v-model="monitor.name" placeholder="最大100个字符，1个中文等于2个字符" :max="100" width="352" />
      </Col>
    </Row>

    <!-- 按钮 -->
    <div class="c-group-submit">
      <Row :gutter="12">
        <Col span="12">
          <error-pop v-model="formErr" :state="Boolean(errRes.length)" :data="errRes" @on-close="errRes = []"></error-pop>
        </Col>
        <Col span="12" class="c-btns-submit">
          <Button @click.stop="cannel">取消</Button>
          <Button type="primary" v-if="editState" :loading="loading" @click.stop="save">
            <span v-if="!loading">保存规则</span>
            <span v-else>提交中...</span>
          </Button>
          <Button type="primary" v-else :loading="loading" @click.stop="submit">
            <span v-if="!loading">新增规则</span>
            <span v-else>提交中...</span>
          </Button>
        </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import validMixin from '../mixins/valid-mixin'
import filterWarns from '../data/filters_warn'
import { mul, div } from '@/common/js/api'
import { isArray, isEmpty, timeout } from '@/common/js/utils'
import { createPreWarn, getPreWarnDetail } from '@/api/manage.model'
import { getSysMember, getSysMedia } from '@/api/common.model'
import { getPtomGroupGames } from '@/api/material.model'
import times, { weeks, days } from '@/components/crontab/times'
import Condition from '@/components/condition/condition-plus'
import ErrorPop from '@/components/error-pop.vue'
import InputLen from '@/components/input/input-len.vue'

// 提交前数组的转换
const fmt_mult = (val) => {
  let mult = []
  if (typeof val === 'string') mult = val.split(',').map((ret) => Number(ret))
  return mult
}
export default {
  name: 'monitordata',
  mixins: [validMixin],
  components: { Condition, ErrorPop, InputLen },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    }
  },
  methods: {
    getData() {
      // 加载动画
      this.$Spin.show()
      getPreWarnDetail({ id: this.monitor.id })
        .then((data) => {
          this.$Spin.hide()
          if (data) {
            const { name, ruleType, dataRange, alertType, monitorTime, ruleInfo, platform, mediaIds, gameGroupIds, alertOpIds } = data
            const { detail, monitor_type } = ruleInfo
            let { type, key, value } = monitorTime
            // 处理传出的value -> index
            value = typeof value === 'string' && value.length ? value.split(',').map((time) => times.indexOf(time)) : [0]

            this.monitor = Object.assign(this.monitor, {
              name,
              rule_type: ruleType,
              data_range: dataRange,
              alert_type: alertType,
              mediaIds: fmt_mult(mediaIds),
              game_group_ids: gameGroupIds.split(',').map(Number),
              operators: fmt_mult(alertOpIds),
              monitor_time: { type, key, value },
              platform,
              monitorCondition: detail,
              satisfy: monitor_type
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    proloadData() {
      this.$Spin.show()
      Promise.all([getPtomGroupGames(), getSysMember(), getSysMedia()]).then((data) => {
        this.$Spin.hide()
        const [groupData, operatorData, mediaData] = data
        if (isArray(groupData)) {
          this.groupData = groupData.map((ret) => {
            return {
              id: ret.groupId,
              name: ret.groupName,
              children: ret.gameIds
            }
          })
        }
        if (isArray(operatorData)) this.operatorData = operatorData
        if (isArray(mediaData)) {
          this.mediaData = mediaData.map((ret) => {
            return {
              id: ret.mediaId,
              name: ret.mediaName
            }
          })
        }
      })
    },
    // 切换媒体初始化
    changeMedia() {
      this.accounData = []
      this.planIds = undefined
      this.accountIds = undefined
    },
    // 改变监控规则
    changeSatisfy(val) {
      this.$set(this.monitor, 'satisfy', val)
    },
    toFloat(key, obj, fixed) {
      if (isEmpty(obj[key])) return
      let val = parseFloat(obj[key])
      if (val < 0) val = 0
      else if (fixed) {
        val = mul(val, 100)
        val = div(Math.floor(val), 100)
      }
      obj[key] = String(val)
    },
    customValid() {
      const err = []
      // 触发条件
      const condiValid = this.monitor.monitorCondition.some((ret) => isEmpty(ret.value))
      if (condiValid) {
        err.push({ feild: '触发条件', msg: '触发条件中的值验证不通过' })
      }
      if (!this.monitor.monitor_time.value?.length) {
        err.push({ feild: '触发条件', msg: '监控频率时间段不能为空' })
      }
      return err
    },
    valid() {
      const rules = [
        {
          name: 'monitor/name',
          require: true,
          min: 2,
          max: 100,
          desc: '规则名称'
        },
        {
          name: 'monitor/mediaIds',
          require: true,
          min: 1,
          desc: '媒体'
        },
        {
          name: 'monitor/game_group_ids',
          require: true,
          min: 1,
          desc: '游戏组'
        },
        {
          name: 'monitor/operators',
          require: true,
          min: 1,
          desc: '提醒人员'
        }
      ]
      this.formErr = false
      return this.invalid(rules)
    },
    buildParams() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }
      const { game_group_ids, mediaIds, operators, monitor_time, satisfy, monitorCondition } = this.monitor

      const params = Object.assign({}, this.monitor, {
        game_group_ids: game_group_ids.join(','),
        media_ids: mediaIds.join(','),
        alert_op_ids: operators.join(','),
        rule_info: {
          monitor_type: satisfy,
          detail: monitorCondition
        },
        monitor_time: {
          type: monitor_time.type,
          key: monitor_time.key,
          value: times.filter((_, index) => monitor_time.value.includes(index)).join(',')
        }
      })

      return params
    },
    submit() {
      const params = this.buildParams()
      if (!params) return

      // 复制取消提交的id
      delete params.id

      this.$Spin.show()
      this.loading = true
      createPreWarn(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 2,
            content: '提交成功！2秒后自动跳转'
          })
          timeout(3000).then(() => {
            this.jump()
          })
        }
      })
    },
    save() {
      this.errRes = [...this.valid(), ...this.customValid()] // 表单验证
      if (this.errRes.length) {
        // 如果错误中断
        this.formErr = true
        return
      }

      const params = this.buildParams()
      if (!params) return
      this.$Spin.show()
      this.loading = true
      createPreWarn(params).then((data) => {
        this.loading = false
        this.$Spin.hide()
        if (data) {
          this.$Message.success({
            closable: true,
            duration: 2,
            content: '编辑成功！2秒后自动跳转'
          })
          timeout(3000).then(() => {
            this.jump()
          })
        }
      })
    },
    jump() {
      this.$router.push({ name: 'prewarnrules' })
    },
    cannel() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>关闭当前页面编辑信息将丢失，是否确定？</p>',
        onOk: () => {
          this.jump()
        }
      })
    }
  },
  data() {
    return {
      ruleData: filterWarns,
      weeks,
      times,
      days,
      monitor: {
        id: this.$route.query.id, // 修改id
        rule_type: 1,
        name: '',
        platform: 0,
        game_group_ids: [],
        mediaIds: [],
        satisfy: 'all',
        monitorCondition: [],
        operators: [], // 提醒人员
        alert_type: 1, // 提醒规则
        monitor_time: {
          type: 'day',
          key: 1,
          value: [0]
        }, // 提醒时间
        data_range: 1 // 数据统计周期
      },
      loading: null,
      formErr: null, // 表单检验状态
      errRes: [], // 错误的数值

      operatorData: [], // 系统人员
      groupData: [], // 游戏组
      mediaData: [] // 媒体
    }
  },
  created() {
    this.proloadData()
    if (this.monitor.id) this.getData()
  }
}
</script>
<style lang="scss" scoped>
.add-form {
  padding-top: 60px;
  height: calc(100% - 40px);
  overflow-y: auto;
  overflow-x: hidden;

  .c-rule-info {
    height: 32px;
    min-width: 168px;
    margin-bottom: 12px;
    display: flex;

    .info-label {
      line-height: 32px;
      width: 36px;
      flex: 0 0 36px;
    }

    .info-content {
      flex: 0 0 auto;
    }
  }

  .item-btn-span {
    margin-right: 12px;
  }

  .m-switch {
    padding: 5px 0;
  }

  .c-group-submit {
    padding: 15px;
    min-width: 1130px;
    background-color: #fff;
    border: 1px solid #eaeaea;
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 #eff1fa;

    .c-btns-submit {
      text-align: right;

      .ivu-btn {
        margin-right: 0;
        margin-left: 20px;
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  /* 表单选项 */
  .row-item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 32px;

    .col-item {
      text-align: right;
    }

    i {
      margin-right: 4px;
      vertical-align: middle;

      &.ivu-icon-md-add {
        margin: 0;
      }
    }

    .item-field {
      font-size: 14px;
      padding-right: 12px;
      height: 32px;
      line-height: 32px;
    }

    /* 必填项 */
    .row-item-must {
      position: relative;
      z-index: 5;

      &:after {
        content: ' ';
        display: inline-block;
        width: 4px;
        height: 4px;
        position: absolute;
        top: 6px;
        right: 0;
        background-color: #f45858;
        border-radius: 3px;
      }
    }
  }

  .m-radio-select {
    height: 90px;
    display: flex;
    align-items: flex-end;

    .ivu-select {
      width: 180px;
    }
  }
}
</style>
